import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "checkAllCheckbox", "removeVehiclesButton"];

  checkboxTargetDisconnected() {
    this.removeVehiclesButtonTarget.disabled = !this.checkboxTargets.some(
      (checkbox) => checkbox.checked
    );
  }

  toggleAllCheckboxes(event) {
    const element = event.target;
    const isChecked = element.checked;

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });

    this.removeVehiclesButtonTarget.disabled = !isChecked || this.checkboxTargets.length === 0;
  }

  toggleCheckbox(event) {
    const element = event.target;
    const isChecked = element.checked;

    if (isChecked) {
      this.checkAllCheckboxTarget.checked = this.checkboxTargets.every(
        (checkbox) => checkbox.checked
      );

      this.removeVehiclesButtonTarget.disabled = false;
    } else {
      // Disable the remove cars button if no checkboxes are checked
      this.removeVehiclesButtonTarget.disabled = this.checkboxTargets.every(
        (checkbox) => !checkbox.checked
      );
      this.checkAllCheckboxTarget.checked = false;
    }
  }
}
